module.exports = __webpack_public_path__ + "static/media/USDC-BUSD.1886b7d0.svg";